import { render, staticRenderFns } from "./HistoricBills.vue?vue&type=template&id=cc10ea16&scoped=true&"
import script from "./HistoricBills.vue?vue&type=script&lang=js&"
export * from "./HistoricBills.vue?vue&type=script&lang=js&"
import style0 from "./HistoricBills.vue?vue&type=style&index=0&id=cc10ea16&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc10ea16",
  null
  
)

export default component.exports